import { render, staticRenderFns } from "./salesRank.vue?vue&type=template&id=f8428faa&scoped=true&"
import script from "./salesRank.vue?vue&type=script&lang=js&"
export * from "./salesRank.vue?vue&type=script&lang=js&"
import style0 from "./salesRank.vue?vue&type=style&index=0&id=f8428faa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8428faa",
  null
  
)

export default component.exports